import { CAPTCHA_SUCCESS, CAPTCHA_FAILURE, CAPTCHA_RESET } from "../actions/UserActions";

const initialState = {
    fetched: false,
    captchaValid: false,
    error: null
}

export default function captchaReducer(state = initialState, action) {

    switch (action.type) {
        case CAPTCHA_SUCCESS:
            return {
                fetched: true,
                captchaValid: true,
                error: null
            };
        case CAPTCHA_FAILURE:
            return {
                fetched: true,
                captchaValid: false,
                error: action.payload
            }
        case CAPTCHA_RESET:
            return {
                fetched: false,
                captchaValid: false,
                error: null
            }
        default:
            return state;
    }
}